//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RoundsBar from './Lifestyle_RoundsBar.vue';

export default {
  name: 'Lifestyle_Rounds',
  components: {
    RoundsBar,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },

};

